// extracted by mini-css-extract-plugin
export default {"editor":"StructureEditor_editor__I3FK6","label":"StructureEditor_label__MOSPd"};